import { BaseRequestModel } from "./BaseModel/BaseRequestModel";

export class getpublicportalsectionscontactusbyid_webportal extends BaseRequestModel{
    ID:number
}